import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "lodash/isEmpty";
import Modal, { setSelectedModal } from "../../Modal";
import { EMPTY_STRING, MODAL_SIZE, USER_ROLES } from "../../../../constants";
import { selectUsers, updateUser } from "../../../../pages/Users";
import {
  fetchUserProfileById,
  selectUser,
} from "../../../../pages/UserProfile";
import Spinner, { SPINNER_NAMES } from "../../Spinner";

const { MD } = MODAL_SIZE;
const { OWNER, ADMIN, USER } = USER_ROLES;
const { UPDATE_USER, FETCH_USER } = SPINNER_NAMES;

const TransferOwnershipModal = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(selectUsers);
  const currentUser = useSelector(selectUser);

  const [selectedUser, setSelectedUser] = useState();

  const updatedUsers = {
    admin: data.filter(({ role }) => role === ADMIN),
    user: data.filter(({ role }) => role === USER),
  };

  const handleClose = () => dispatch(setSelectedModal());

  const handleOwnershipTransfer = () => {
    dispatch(updateUser({ id: currentUser.id, user: { role: ADMIN } })).then(
      (res) => {
        if (res.payload) {
          dispatch(
            updateUser({ id: selectedUser, user: { role: OWNER } })
          ).then(() =>
            dispatch(fetchUserProfileById(currentUser.sub)).then((res) => {
              res.payload && handleClose();
            })
          );
        }
      }
    );
  };

  const footer = (
    <div className="flex justify-end p-4 border-t border-gray-700">
      <button
        className="btn btn-primary"
        onClick={handleOwnershipTransfer}
        disabled={!selectedUser}
      >
        <Spinner name={[UPDATE_USER, FETCH_USER]} persistSize>
          Transfer Ownership
        </Spinner>
      </button>
    </div>
  );

  return (
    <div>
      <Modal
        title="Transfer Ownership"
        size={MD}
        handleClose={handleClose}
        footer={footer}
      >
        <div className="flex justify-center form-group items-center p-6">
          <div className="flex flex-col gap-1">
            <label className="text-white">
              Select a user to transfer ownership to:
            </label>
            <select
              onChange={(e) => setSelectedUser(e.target.value)}
              defaultValue={EMPTY_STRING}
              className="rounded"
            >
              <option disabled value={EMPTY_STRING}>
                Select a user
              </option>
              {Object.entries(updatedUsers).map(
                ([userRole, users]) =>
                  !isEmpty(users) && (
                    <optgroup
                      className="capitalize"
                      label={userRole}
                      key={userRole}
                    >
                      {users.map(({ name, email, id }) => (
                        <option key={id} value={id}>
                          {`${name} (${email})`}
                        </option>
                      ))}
                    </optgroup>
                  )
              )}
            </select>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TransferOwnershipModal;
